export default "__VITE_ASSET__bwi9bX6$__"